export default __webpack_public_path__ + "static/Theadventurebegins-7ae40f100af0ec9bf0a75b82564e1e6f.png";